import {
  GET_STUDENT_HOMEWORK_FILES_STARTED,
  GET_STUDENT_HOMEWORK_FILES_COMPLETED,
  GET_STUDENT_HOMEWORK_FILES_FAILED,
  GET_STUDENT_HOMEWORK_FILE_STARTED,
  GET_STUDENT_HOMEWORK_FILE_COMPLETED,
  GET_STUDENT_HOMEWORK_FILE_FAILED,
  UPLOAD_STUDENT_HOMEWORK_FILE_STARTED,
  UPLOAD_STUDENT_HOMEWORK_FILE_COMPLETED,
  UPLOAD_STUDENT_HOMEWORK_FILE_FAILED,
  DELETE_STUDENT_HOMEWORK_FILE_STARTED,
  DELETE_STUDENT_HOMEWORK_FILE_COMPLETED,
  DELETE_STUDENT_HOMEWORK_FILE_FAILED,
} from '../actions/types';

const initialState = {
  fetched: false,
  files: [],
  success: false,
  error: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_STUDENT_HOMEWORK_FILES_STARTED:
      return {
        ...state,
        fetched: false,
        error: false,
      };
    case GET_STUDENT_HOMEWORK_FILES_COMPLETED:
      return {
        ...state,
        fetched: true,
        files: action.payload,
      };
    case GET_STUDENT_HOMEWORK_FILES_FAILED:
      return {
        ...state,
        fetched: true,
        error: true,
      };
    case GET_STUDENT_HOMEWORK_FILE_STARTED:
      return {
        ...state,
        fetched: false,
        success: false,
        error: false,
      };
    case GET_STUDENT_HOMEWORK_FILE_COMPLETED:
      return {
        ...state,
        fetched: true,
        success: true,
      };
    case GET_STUDENT_HOMEWORK_FILE_FAILED:
      return {
        ...state,
        fetched: true,
        error: true,
      };
    case UPLOAD_STUDENT_HOMEWORK_FILE_STARTED:
      return {
        ...state,
        success: false,
        fetched: false,
        error: false,
      };
    case UPLOAD_STUDENT_HOMEWORK_FILE_COMPLETED:
      return {
        ...state,
        fetched: true,
        success: true,
      };
    case UPLOAD_STUDENT_HOMEWORK_FILE_FAILED:
      return {
        ...state,
        fetched: true,
        error: true,
      };
    case DELETE_STUDENT_HOMEWORK_FILE_STARTED:
      return {
        ...state,
        fetched: false,
        success: false,
        error: false,
      };
    case DELETE_STUDENT_HOMEWORK_FILE_COMPLETED:
      return {
        ...state,
        fetched: true,
        success: true,
      };
    case DELETE_STUDENT_HOMEWORK_FILE_FAILED:
      return {
        ...state,
        fetched: true,
        error: true,
      };
    default: return state;
  }
};
